import styled from "styled-components";

import { BiggerThanXLarge } from "../../style/breakpoints";

export const ConfDate = styled.h3`
  text-align: center;
  font-size: 1.6rem;
`;

export const SubscribeButtonWrapper = styled.div`
  display: none;

  ${BiggerThanXLarge} {
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;

export const MobileSubscribeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4em;

  ${BiggerThanXLarge} {
    display: none;
  }
`;

export const LogoImg = styled.img`
  justify-content: center;

  width: 70%;
  margin: 3rem auto;
`;
